<template>
  <component
    :is="tag"
    :type="tag === 'button' ? 'button' : undefined"
    :class="badge({ variant, size, ring, className: props.class })"
  >
    <component :is="icon" v-if="icon" class="size-3 shrink-0" aria-hidden="true" />
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { badge, type BadgeVariant } from '@carvia/theme/lib/cva/badge';
import type { CvaComponentProps } from '@carvia/theme/lib/cva/CvaComponentProps.ts';
import { computed, useAttrs, type Component, type HTMLAttributes } from 'vue';

type BadgeProps = CvaComponentProps<typeof badge>;

const props = withDefaults(
  defineProps<{
    variant?: BadgeVariant;
    size?: BadgeProps['size'];
    ring?: boolean;
    icon?: Component;
    class?: HTMLAttributes['class'];
  }>(),
  {
    variant: 'neutral',
    size: 'sm',
    ring: false,
  },
);

const attrs = useAttrs();

const tag = computed(() => (attrs.onClick ? 'button' : 'span'));
</script>
